import axios from 'axios';
import _ from 'lodash';
import { _csrfToken_ } from '../Constants';
import qs from 'qs';

export default class Http {

	static getRequiredParams = (data) => {
		return {
			timeZone: data.timeZone,
			loggedInCompanyId: data.user.companyId,
			loggedInUserId: data.user.userId,
			[_csrfToken_]: data[_csrfToken_],
		};
	}
	
	static  addParameterToUrl = (url, name, value) => {
		if (_.isEmpty(name) || _.isEmpty(value)) {
			return url;
	    }
	
	    const separator = url.indexOf('?') === -1 ? '?' : '&';
	    return url + separator + encodeURIComponent(name) + '=' + encodeURIComponent(value);
	}
	

    static async postData  (url, data) {
        try {
            const response = await axios.post(
				url, 
            	qs.stringify(data),
				{
					headers: { "Content-Type": "application/x-www-form-urlencoded" }
				}
			);
            return response.data;
        } catch (e) {
            console.error(e);
            return e?.response?.data;
        }
    }
	
}